// Module
var code = "<footer> Copyright &copy; DentaDesk </footer> ";
// Exports
module.exports = code;